
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.25 19.25a.752.752 0 01-.75-.75 6.758 6.758 0 00-6.75-6.75 6.733 6.733 0 00-4.964 2.225L13.5 16.69c.283.283.439.66.439 1.061 0 .4-.156.777-.44 1.061a1.487 1.487 0 01-1.059.438H2.25A2.253 2.253 0 010 17V6.808c0-.401.156-.777.439-1.061.283-.283.66-.44 1.06-.44.401 0 .777.156 1.061.439l1.952 1.951a12.62 12.62 0 016.744-1.954c.743 0 1.495.066 2.233.196a12.633 12.633 0 018.21 5.23A12.648 12.648 0 0124 18.501a.751.751 0 01-.75.749zM1.5 17c0 .414.336.75.75.75h10.189l-3.191-3.192a.746.746 0 01-.075-.974 8.194 8.194 0 016.576-3.334c1.53 0 3.013.427 4.294 1.209a11.136 11.136 0 00-6.816-4.042 11.378 11.378 0 00-1.971-.173c-2.296 0-4.513.703-6.412 2.032a.741.741 0 01-.959-.084L1.5 6.807V17z"}})])
          )
        }
      }
    